/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { css } from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  radius,
  spacing
} from '../../theme';

const roleVariants: {
  [key: string]: {
    borderColor?: string | ((key: any) => any);
  };
} = {
  error: {
    borderColor: color('negative_700')
  }
};

const sizeVariants: {
  [key: string]: {
    padding?: string | ((key: any) => string);
    fontSize?: string | ((key: any) => string);
    height?: string;
  };
} = {
  sm: {
    padding: spacing('sm'),
    fontSize: fontSize('xs'),
    height: '2.5rem'
  }
};

export const StyledInputTextArea = styled.textarea<{
  sizes?: string;
  variant?: string;
}>`
  width: 100%;
  min-width: ${spacing('xl7')};
  padding: 1.25rem;
  font-family: ${fontFamily('sans')};
  font-size: ${fontSize('sm')};
  font-weight: ${fontWeight('medium')};
  color: ${color('text_default')};
  border-radius: ${radius('md')};
  border: 2px solid ${color('midnight_200')};
  transition: 0.3s;
  resize: vertical;

  ${({ variant }) =>
    variant &&
    roleVariants[variant] &&
    css`
      border-color: ${roleVariants[variant].borderColor} !important;
    `}

  ${({ sizes }) =>
    sizes &&
    sizeVariants[sizes] &&
    css`
      padding: ${sizeVariants[sizes].padding};
      font-size: ${sizeVariants[sizes].fontSize};
    `}

  &::placeholder {
    color: ${color('text_placeholder')};
  }

  &:hover {
    border-color: ${color('midnight_400')};
  }

  &:focus {
    outline: 0;
    border-color: ${color('midnight_850')};
    box-shadow: 0 0 0 4px ${color('midnight_150')};
  }
`;
